<div class="m-content"  [ngClass]="{'padding-top-right-bottom-zero': onlyTable, 'padding-right-25': !onlyTable}">
	<div class="m-portlet m-portlet--mobile">
		<div class="m-portlet__head" *ngIf="data?.label">
			<div class="m-portlet__head-caption">
				<div class="m-portlet__head-title">
					<h3 class="m-portlet__head-text">
						{{data.label}}
					</h3>
				</div>
			</div>
		</div>
		<div [ngClass]="{'m-portlet': !onlyTable}">
		<!-- <div class="m-portlet"> -->
			<div class="m-portlet__body">
				<ul class="nav nav-pills nav-fill" role="tablist">
				<!-- <ul class="nav nav-pills nav-fill row flex-row" role="tablist"> -->
					<li class="nav-item" *ngFor="let tab of data.tabs">
					<!-- <li class="nav-item col-md-2" *ngFor="let tab of data.tabs"> -->
						<a class="nav-link" [ngClass]="{'active': tab.active}" (click)="switchTab(tab.id)"  >
							{{tab.name}}
						</a>
					</li>
					<!-- <span class="col-md-1 col-lg-1 col-sm-1 right-align" *ngIf="data?.showCount">
						<span class="m-menu__link-badge">
							<span class="m-badge m-badge--info">Count: {{data?.pagination?.count || 0}}</span>
						</span>
					</span> -->
				</ul>
				<label *ngIf="data?.showCount">
					<b>Batches Count:</b> {{data?.pagination?.count || 0}}
				</label>
				<ng-container *ngFor = "let tab of data.tabs">
					<app-table *ngIf="formLoaded && tab.active && tab.table" (selectFilterChange)="onSelectFilterChange($event)" [table]="tab.table" (filter)="onFilter($event, tab.id)" [isResetButton]="resetButton" (pageNumberChange)="onPageNumberChange($event, tab.id)"
					(recordsPerPageChange)="onRecordsPerPageChange($event, tab.id)"></app-table>

					<app-table *ngIf="formLoaded && tab.active && !tab.table" (selectFilterChange)="onSelectFilterChange($event)" [dynamicClasses]="tab.table.dynamicClasses" [data]="tab.table.data" [headers]="tab.table.headers"
					[filters]="tab.table.filters" (filter)="onFilter($event, tab.id)" (pageNumberChange)="onPageNumberChange($event, tab.id)" [fieldMapping]="tab.table.fieldMapping"
					(recordsPerPageChange)="onRecordsPerPageChange($event, tab.id)" [pagination]="tab.table.pagination" [searchFilters]="tab.table.searchFilters" [appliedFilter]="tab.table.defaultFilters" ></app-table>
				</ng-container>
			</div>
		</div>
	</div>
</div>
